import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentSubmitPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: DocumentSubmitPayload) =>
    $actions.documentSign.submitSignedDocument(dispatch, payload),
  );
};
